import React, { useState } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import WhyQualicore from './components/WhyQualicore';
import Workflow from './components/Workflow';
import Features from './components/Features';
import Metrics from './components/Metrics';
import AISection from './components/AISection';
import Integrations from './components/Integrations';
import ProductDetails from './components/ProductDetails';
import Roadmap from './components/Roadmap';
import Footer from './components/Footer';
import { BrowserRouter } from 'react-router-dom';

export default function App() {
  const [showModal, setShowModal] = useState(false);
  return (
    <BrowserRouter basename="/microsite/">
    <div style={{ minHeight: '100vh', background: '#0D1117' }}>
      <Navbar onBookDemo={() => setShowModal(true)} />
      <Hero onBookDemo={() => setShowModal(true)} />
      <WhyQualicore />
      <Workflow />
      <Features />
      <Metrics />
      <AISection />
      <Integrations />
      <ProductDetails onBookDemo={() => setShowModal(true)} />
      <Roadmap showModal={showModal} setShowModal={setShowModal} />
      <Footer onBookDemo={() => setShowModal(true)} />
    </div>
    </BrowserRouter>
  );
}
